import React from 'react';
import styled from 'react-emotion';
import {
  theme as nextTheme,
  Modal,
  IconButton as AUIIconButton,
} from '@ublend-npm/aulaui-next';
import {
  Tooltip,
  styled as styledII,
  tooltipClasses,
} from '@ublend-npm/aulaui-core';
import { DARK } from '@core/constants/theme';
import UnstyledMessageTable from '../MessageTable.container';

export const MessageTable = styled(UnstyledMessageTable)`
  position: unset;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
`;

export const WriteZoneContainer = styledII('div')(({ theme: coreTheme }) => ({
  flexShrink: 0,
  minHeight: '60px',
  borderTop: '1px solid #e0e0e0',
  boxSizing: 'border-box',
  width: '100%',

  '&:focus-within': {
    borderTopColor: coreTheme.palette.primary.main,
  },

  '& p': {
    color: coreTheme.palette.mode === DARK ? '#fff' : '#000',
  },
  'svg path': {
    fill: coreTheme.palette.mode === DARK ? '#fff' : '#000',
  },
  '& [role="textbox"]': {
    fontFamily: 'Roboto, sans-serif',
    overflowWrap: 'anywhere',
  },
}));

export const HeaderAddonContainer = styled('div')`
  display: flex;
`;

export const AddonContainer = styled('div')`
  flex-shrink: none;
`;

export const ModalWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  height: inherit;
`;

export const ModalStyled = styled(Modal)`
  position: absolute !important;
`;

export const ModalContent = styled('div')`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  height: 35rem;
`;

export const ActionContainer = styled('div')`
  flex-shrink: none;
`;

export const IconButton = styled(AUIIconButton)`
  min-width: 40px;
  margin-left: ${nextTheme.spacing.small};
  background-color: ${nextTheme.color.grayLight};
  color: ${nextTheme.color.designSystem.purple70};

  &:hover {
    color: ${nextTheme.color.designSystem.purple70};
  }

  &:active {
    color: ${nextTheme.color.designSystem.purple70};
  }
`;

export const StyledTooltip = styledII(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.mode === DARK ? '#D7D2DF' : '#5D536C',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.mode === DARK ? '#D7D2DF' : '#5D536C',
    color:
      theme.palette.mode === DARK
        ? theme.palette.common.black
        : theme.palette.common.white,
  },
}));
